import React from "react";

const CookiePolicy = () => {
  return (
    <div className="bg-white p-5 text-justify">
      <div className="d-flex justify-content-end pt-5">
        <a href="/privacy-policy" className="pr-5">
          Privacy policy
        </a>
        <a href="/customer-awareness-policy" className="pr-5">
          Customer awareness policy
        </a>
      </div>
      <div>
        <h1>COOKIE POLICY</h1>
        Please read this cookie policy (“cookie policy”, "policy") carefully
        before using this website (“website”, "service") operated by Trip ("us",
        'we", "our").
      </div>
      <div className="pt-3">
        <h5>What are Cookies?</h5>
        Cookies are simple text files that are stored on your computer or mobile
        device by a website’s server. Each cookie is unique to your web browser.
        It will contain some anonymous information such as a unique identifier,
        website’s domain name, and some digits and numbers.
      </div>
      <h5 className="pt-3">What type of cookies do we use?</h5>
      <div className="pt-3">
        <h5>Necessary Cookies</h5>
        Necessary cookies allow us to offer you the best possible experience
        when accessing and navigating through our website and using its
        features. For example, these cookies let us recognize that you have
        created an account and have logged into that account.
      </div>
      <div className="pt-3">
        <h5>Functionality Cookies</h5>Functionality cookies let us operate the
        site in accordance with the choices you make. For example, we will
        recognize your username and remember how you customized the site during
        future visits.
      </div>
      <div className="pt-3">
        <h5>Performance Cookies</h5>These are used to gather data on how users
        use our website and the pages visited most often. They monitor only the
        performance of our website as the user interacts with it. All data
        collected by these cookies are anonymous and are solely used to improve
        the functionality of our website.
      </div>
      <div className="pt-3">
        <h5>How to delete Cookies?</h5>If you want to restrict or block the
        cookies that are set by our website, you can do so through your browser
        setting.
      </div>
      <div className="pt-3">
        Contact us If you have any questions about this policy or our use of
        cookies, please contact us at{" "}
        <a href="mailto:dpo@avitechng.com">dpo@avitechng.com</a>.
      </div>
    </div>
  );
};

export default CookiePolicy;



// WEBPACK FOOTER //
// ./src/views/policies/cookie-policy.js